// extracted by mini-css-extract-plugin
module.exports = {"menu_texts":"MenuList_menu_texts__2FKBX","menu_app_bar":"MenuList_menu_app_bar__31IAF","menu_top":"MenuList_menu_top__2LmQV"};